export const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  EMAIL,
};
